import axiosInstance from "../../../api/AxiosInstance";
import { endpoints } from "../../../services/endpoints";
import { getQueriesRequest, getQueriesRequestError, getQueriesRequestSuccess } from "../../slices/Query/GetQueriesSlice";

export const GetQueriesApi = (page, limit) => async (dispatch) => {
    const queryParams = new URLSearchParams({
        page: page,
        limit: limit,
        // status: status,
        // search: search
    }).toString();

    const urlWithParams = `${endpoints.getQueries}?${queryParams}`;

    try {
        dispatch(getQueriesRequest());
        axiosInstance({
            method: "GET",
            url: urlWithParams,
            headers: { "Content-Type": "application/json" },
        })
            .then((resp) => {
                return dispatch(getQueriesRequestSuccess(resp?.data));
            })
            .catch((error) => {
                const _error = {
                    data: error?.response?.data?.message || error?.message,
                    status: error?.response?.status || error?.status,
                };
                return dispatch(getQueriesRequestError(_error));
            });
    } catch (error) {
    }
};
